import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { WarningLightDetailsResponseModel } from '../../../business-entities/warning-light-view-model';
import { WarningLightService } from '../../../business-services/warninglight.service';
import { ImageService } from '../../../services/image.service';

@Component({
  selector: 'app-add-edit-warning-light',
  templateUrl: './add-edit-warning-light.component.html'
})
export class AddEditWarningLightComponent implements OnInit {

  Id: number;
  WarningLightForm: FormGroup;
  languageList: any[];
  imageBaseData: string | ArrayBuffer = null;
  warningLightDetail: WarningLightDetailsResponseModel;

  image: string | ArrayBuffer;
  constructor(
    private warningLightService: WarningLightService,
    private activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private currentLanguageService: CurrentLanguage,
    private imageService:ImageService,
    private translate : TranslateService,
    private toaster: ToastrService,
    private spinner: NgxSpinnerService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.Id = this.warningLightService.Id;


    this.WarningLightForm = this.formBuilder.group({
      warningLight: new FormArray([]),
      Image: ['',Validators.required],
      ImageBinaryData: [''],
      MimeType: [''],
      isActive: [true],
    });
    this.languageList = this.currentLanguageService.LanguageList;
    this.getLanguage();
    if (this.Id > 0) {
      this.getWarningLightDetails(this.Id);
    }
  }

  getLanguage() {
    const number = this.currentLanguageService.LanguageList.length;
    if (this.t.length < number) {
      for (let i = this.t.length; i < number; i++) {
        this.t.push(this.formBuilder.group({
          languageId: ['',],
          name: ['', Validators.required],
          description: ['', Validators.required],
        }));
      }
    } else {
      for (let i = this.t.length; i >= number; i--) {
        this.t.removeAt(i);
      }
    }
  }

  get t() { return this.cpf.warningLight as FormArray; }

  get cpf() {
    return this.WarningLightForm.controls;
  }

  onChangeFileUpload(files: FileList) {
    const me = this;
    const file = files[0];
    this.WarningLightForm.controls["MimeType"].setValue(files[0]?.type);
    this.WarningLightForm.controls["Image"].setValue(files[0]?.name);
    this.WarningLightForm.value.Image = files[0]?.name;
    this.WarningLightForm.value.MimeType = files[0]?.type ;
    let imageSize = files[0]?.size;
    let imgerrormsg = this.translate.instant("lblAllowedJPGPNGSVG");
    const reader = new FileReader();
    reader.readAsDataURL(file);
    const isValidFormat=this.imageService.validateImageFormat(this.WarningLightForm.value.MimeType);
    if(isValidFormat)
    {
      if(imageSize < 100000)
      {
        reader.onload = (_readerEvent) => {
          if(this.Id>0) 
          {
            this.warningLightDetail.warningLightDetails[0].logo = "";
          }
          me.imageBaseData = reader.result;
          this.WarningLightForm.controls["ImageBinaryData"].setValue(reader.result.toString().replace('data:' + this.WarningLightForm.value.MimeType + ';base64,', ''));
          this.WarningLightForm.value.ImageBinaryData = reader.result.toString().replace('data:' + this.WarningLightForm.value.MimeType + ';base64,', '');
          this.image = me.imageBaseData;
          };
      }
      else
      {
        let errormsg = this.translate.instant("lblSizeExceedError");
        this.toaster.error(errormsg);
      }

   }

   else {
    this.toaster.error(imgerrormsg);
  }
    reader.onerror = function (_error) {
      // This is intentional
    };
  }



  async getWarningLightDetails(id) {
    this.spinner.show();

    await this.warningLightService.getWarningLightById(id).then((response) => {
      this.warningLightDetail = response.responseObject;
      this.cdr.detectChanges();
      this.image=this.warningLightDetail.warningLightDetails[0].logo;
      this.WarningLightForm.patchValue({
        Image: this.warningLightDetail.warningLightDetails[0].logo,
        MimeType: this.warningLightDetail.warningLightDetails[0].mimeType,
        warningLight: this.warningLightDetail.warningLightLanguageDetails,
        isActive:this.warningLightDetail.warningLightDetails[0].isActive,
      });
      this.cdr.detectChanges();
      this.spinner.hide();
    }, _error => {
      this.spinner.hide();
    });

  }

  addEditWarningLightForm()
  {
    let addSuccessMessage = this.translate.instant("lblWarningLightAdded");
    let editSuccessMessage = this.translate.instant("lblWarningLightAreEdited");
    let addFailedMessage = this.translate.instant("lblFailedToAddWarningLight");
    let editFailedMessage = this.translate.instant("lblFailedToEditWarningLight");

    this.spinner.show();

    //if edit and image not changed
    if(this.Id>0 && !this.WarningLightForm.controls['ImageBinaryData'].value )
    {
      this.WarningLightForm.value.Image=this.warningLightDetail.warningLightDetails[0].fileName;
      this.WarningLightForm.controls["Image"].setValue(this.warningLightDetail.warningLightDetails[0].fileName);
    }

    let viewModel = {
      IsActive:this.WarningLightForm.controls['isActive'].value,
      Lnlnvalue: this.WarningLightForm.controls['warningLight'].value,
      Image: this.WarningLightForm.controls['Image'].value ? this.WarningLightForm.controls['Image'].value : "",
      MimeType:  this.WarningLightForm.controls['MimeType'].value ? this.WarningLightForm.controls['MimeType'].value : "",
      ImageBinaryData: this.WarningLightForm.controls['ImageBinaryData'].value ? this.WarningLightForm.controls['ImageBinaryData'].value: "",
      Id: this.warningLightService.Id,
    }

    this.warningLightService.AddUpdateWarningLight(viewModel).then(res => {
      if (res.responseCode === Constant.SuccessResponseCode) {
        if (res.responseObject) {
          if (res.responseObject.isSuccess) {
            let successMessage = (this.warningLightService.Id == 0) ? addSuccessMessage : editSuccessMessage
            this.toaster.success(successMessage);
            this.spinner.hide();
            this.activeModal.close({ success: true });
          }
          else {
            this.spinner.hide();
           
            let errormsg = (this.warningLightService.Id == 0) ? addFailedMessage : editFailedMessage
            this.toaster.error(errormsg);
          }
        }

      }
      else {
        let errorMessage = (this.warningLightService.Id == 0) ? addFailedMessage : editFailedMessage
        this.spinner.hide();
        this.toaster.error(errorMessage);
      }
    }, _error => {
      let errorMessage = (this.warningLightService.Id == 0) ? addFailedMessage : editFailedMessage
      this.spinner.hide();
      this.toaster.error(errorMessage);
    });
  }

  OnClose() {
    
    this.activeModal.close({ success: false });
  }

  onChangeIsActive(event)
  {
    this.WarningLightForm.value.isActive = event.target.checked;
    this.WarningLightForm.controls["isActive"].setValue(event.target.checked);
  }

}
